// extracted by mini-css-extract-plugin
module.exports = {"list":"InputRange_list__Ljhho"};